import { sortBy } from 'ramda';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { supplierMaterialsService } from 'services/materialService';

import { getGroupId } from 'store/session/selectors';

import {
  types,
  init,
  receiveClasses,
  receiveFamilies,
  receiveMaterials,
  receiveMaterialSelectorSettings,
  receiveSupplierMaterials,
  receiveStoredMaterialOptionsForCascader,
  updateStoredMaterialOptionsForCascader,
} from './actions';
import { getMaterialOptionsForCascader } from './reducer';

export default function* root() {
  yield takeLatest(
    types.UPDATE_STORED_MATERIAL_OPTIONS_FOR_CASCADER,
    watchUpdateStoredMaterialOptionsForCascader,
  );
  yield takeLatest(
    types.RECEIVE_SUPPLIER_MATERIAL_FROM_GET_OR_CREATE,
    watchReceiveSupplierMaterialFromGetOrCreate,
  );
  yield takeLatest(types.INIT_MATERIAL_STORE, watchInitMaterialStore);
}

const sortByName = sortBy((x) => x.name.toLowerCase());

export function* initMaterialStore() {
  yield put(init.begin());
  try {
    const groupId = yield select(getGroupId);
    const [materialInfo, selectorSettings] = yield all([
      call(supplierMaterialsService.fetchMaterialInfo, groupId),
      call(supplierMaterialsService.fetchMaterialSelectorSettings, groupId),
    ]);
    const { materialClasses, materialFamilies, materials, supplierMaterials } =
      materialInfo;
    const sortedClasses = sortByName(materialClasses);
    const sortedFamilies = sortByName(materialFamilies);
    const sortedMaterials = sortByName(materials);
    yield all([
      put(receiveClasses(sortedClasses)),
      put(receiveFamilies(sortedFamilies)),
      put(receiveMaterials(sortedMaterials)),
      put(receiveSupplierMaterials(supplierMaterials)),
      put(receiveMaterialSelectorSettings({ selectorSettings })),
      put(updateStoredMaterialOptionsForCascader()),
      put(init.success()),
    ]);
  } catch (error) {
    yield put(init.failure(error));
  }
}

function* watchUpdateStoredMaterialOptionsForCascader() {
  const { cascaderOptions: materialOptionsForCascader, excludedMaterialsById } =
    yield select(getMaterialOptionsForCascader);
  yield put(
    receiveStoredMaterialOptionsForCascader({
      excludedMaterialsById,
      materialOptionsForCascader,
    }),
  );
}

function* watchReceiveSupplierMaterialFromGetOrCreate() {
  yield put(updateStoredMaterialOptionsForCascader());
}

function* watchInitMaterialStore() {
  yield call(initMaterialStore);
}
